<template>
  <v-app-bar height="120px" class="first_app_bar px-5" dark app>
    <v-toolbar-items class="center">
      <v-container class="pa-1">
        <v-btn fab color="#2722a6" @click="toggleSideBar"
          ><v-icon large>mdi-menu</v-icon></v-btn
        >
      </v-container>
    </v-toolbar-items>
    <v-toolbar-items class="padding-nav-bar nav_bar_tittle">
      <v-container class="center">
        <h1 style="color: #ffab5d" class="mb-0">NEKO HR</h1>
      </v-container>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="!legacyTimerRetired" class="padding-nav-bar">
      <Timer :button-show="false" :icon-show="true" :name-show="true" />
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items class="user_info">
      <v-row class="center">
        <v-avatar
          class="user_avatar"
          style="border: 5px solid gray; cursor: pointer"
          height="80px"
          @click="$router.push({path: '/profile'})"
          width="80px"
          ><v-img src="@/assets/image/Nekologic.png"></v-img
        ></v-avatar>
        <v-col>
          <v-row>{{ userProfileData.username }} </v-row>
          <v-row>
            <v-col class="pa-0">
              <v-progress-linear
                :value="10"
                class="progress_linear_indicator"
                color="#f2db06"
                height="20px"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <v-row> Level: {{}} </v-row>
        </v-col>
      </v-row>
    </v-toolbar-items>
    <div class="space" />
  </v-app-bar>
</template>
<script>
import {mapGetters} from "vuex";
import Timer from "./Timer.vue";
import {isLegacyTimerRetired} from "@/config/legacyTimerConfig";
import options from "../../../options";

const safeAreaInsets = require("safe-area-insets");

export default {
  name: "NavBar",
  components: {
    Timer,
  },
  props: ["isLoggedIn"],
  mounted() {
    safeAreaInsets.onChange((newInsets) => {
      this.safeAreaOffset = newInsets.top;
    });
  },
  computed: {
    ...mapGetters(["userProfileData"]),
    legacyTimerRetired() {
      return isLegacyTimerRetired();
    },
    buildVersion() {
      return options.buildType + options.commitHash;
    },
  },
  data() {
    return {
      value: this.isLoggedIn,
      safeAreaOffset: safeAreaInsets.top,
    };
  },
  methods: {
    toggleSideBar() {
      this.$emit("side-menu-pressed");
    },
  },
};
</script>

<style scoped>
.first_app_bar {
  padding: 0px;
  background: linear-gradient(
    0deg,
    rgba(21, 19, 89, 1) 0%,
    rgba(42, 37, 173, 1) 100%
  );
}
.second_app_bar {
  background: linear-gradient(
    0deg,
    rgba(42, 95, 147, 1) 0%,
    rgba(58, 131, 203, 1) 100%
  );
}
.v-item--active {
  color: brown;
  background-color: whitesmoke;
}
.padding-nav-bar {
  padding: 1rem;
  margin: 0.1rem;
}
.timer-icon {
  color: black;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.timer_button {
  padding: 5px;
}
.progress_linear_indicator {
  border: 5px solid grey;
  border-radius: 20px;
  width: 150px;
}
.space {
  width: 6px;
}
.user_info_drawer {
  display: none;
}

/* Small devices (portrait tablets and large phones, 768px and up) */
@media only screen and (max-width: 1165px) {
  .nav_bar_tittle {
    display: none;
  }

  .progress_linear_indicator {
    width: 125px;
  }
}

/* Small devices (portrait tablets and large phones, 768px and up) */
@media only screen and (max-width: 768px) {
  .user_avatar {
    display: none;
  }
  .user_info {
    display: none;
  }
  .user_info_drawer {
    display: block;
  }
}
@media only screen and (max-width: 640px) {
  .project_timer_avatar {
    display: none;
  }
  .first_app_bar >>> .v-toolbar__content {
    padding: 0px !important;
  }
  .space {
    width: 12px;
  }
  .time_count {
    font-size: 20px;
  }
  .center {
    padding: 5px;
  }
}

/* Extra small devices (phones, 400px and down) */
@media only screen and (max-width: 400px) {
}
</style>
